<template>
  <div
    v-if="aktifMi"
    class="mb-3 sm:mb-4 flex items-center gap-3 p-3 rounded-lg border-l-4 zemin-olumsuz kenar-olumsuz"
  >
    <i class="pi pi-eye renk-olumsuz text-xl shrink-0"></i>
    <span class="flex-1 text-sm font-semibold renk-olumsuz">
      <span class="hidden sm:inline">{{ mesajUzun }}</span>
      <span class="sm:hidden">{{ mesajKisa }}</span>
    </span>
    <Button
      label="Konsola Dön"
      icon="pi pi-sign-out"
      severity="help"
      :loading="cikisIslemi"
      @click="konsolaDon"
    />
  </div>
</template>

<script>
import AuthService from "@/services/auth.service";

// SK-S: sirkete gec (impersonation) aktifken tenant arayuzunun ustunde surekli gorunen serit —
// LisansUyariSeridi ile ayni desen, ama kapatilamaz (guvenlik gostergesi gizlenmemeli).
export default {
  name: "ImpersonasyonSeridi",
  data() {
    return {
      aktifMi: AuthService.sirketeGecAktifMi(),
      bilgi: AuthService.sirketeGecBilgi(),
      cikisIslemi: false,
    };
  },
  computed: {
    mesajUzun() {
      if (!this.bilgi) return "";
      return `"${this.bilgi.SirketAdi}" hesabını destek amaçlı görüntülüyorsunuz — sağlayıcı: ${this.bilgi.SaglayiciAdi}`;
    },
    mesajKisa() {
      if (!this.bilgi) return "";
      return `Destek görüntülemesi: ${this.bilgi.SirketAdi}`;
    },
  },
  methods: {
    konsolaDon() {
      if (this.cikisIslemi) return;
      this.cikisIslemi = true;
      AuthService.sirketeGecBitir()
        .then(() => {
          this.$router.push("/sistem/sirketler").then(() => window.location.reload());
        })
        .catch(() => {
          this.cikisIslemi = false;
        });
    },
  },
};
</script>
